import moment from "moment-timezone";

interface OwnProps {
	value?: string | null;
	hideTimezone?: boolean;
}

export const TIMEZONE = "UTC";

export const toJSDate = (value: string) => {
	return moment(value.replace(`[${TIMEZONE}]`, "")).toDate();
};

export const utcFormatDateTime = (value: string, includeTime = true) => {
	return moment(value.replace(`[${TIMEZONE}]`, ""))
		.tz(TIMEZONE, false)
		.format(`DD.MM.YYYY${includeTime ? " HH:mm" : ""}`);
};

export const formatDateTime = (value: string) => {
	return moment(value.replace(`[${TIMEZONE}]`, ""))
		.tz(moment.tz.guess())
		.format("DD.MM.YYYY HH:mm");
};

export const formatDateTimeAsCalendarDate = (value: string, includeTime = true) => {
	if (!value) return undefined;
	const cleaned = value.replace(/\[[^\]]+\]$/, "");
	const m = moment.parseZone(cleaned);
	const date = m.isValid() ? m.toDate() : undefined;
	return date ? moment(date).format(`DD.MM.YYYY${includeTime ? " HH:mm" : ""}`) : "";
};

export const DateTimeDisplay = ({ value, hideTimezone }: OwnProps) => {
	if (!value) {
		return null;
	}

	const formattedDateTime = formatDateTime(value);

	if (hideTimezone) {
		return <span>{formattedDateTime}</span>;
	}

	return (
		<div>
			<div>{formattedDateTime}</div>
			{!hideTimezone && <small>{moment.tz.guess()}</small>}
		</div>
	);
};
